/** Rotas do app em um lugar só. Nenhum componente escreve caminho na mão. */
export const routes = {
  home: '/',
  search: (query?: string) =>
    query ? `/busca?q=${encodeURIComponent(query)}` : '/busca',
  category: (slug: string) => `/categoria/${slug}`,
  product: (slug: string) => `/produto/${slug}`,

  login: '/entrar',
  register: '/criar-conta',
  forgotPassword: '/recuperar-senha',

  profile: '/perfil',
  profilePersonalData: '/perfil/dados-pessoais',
  profileSecurity: '/perfil/seguranca',
  shoppingList: '/ja-comprados',

  admin: '/admin/produtos',
  adminNewProduct: '/admin/produtos/novo',
  adminEditProduct: (id: string) => `/admin/produtos/${id}`,
} as const
